<template>
  <v-container fluid>
    <v-card flat>
      <v-col> </v-col>
      <v-toolbar>
        <v-icon>comment</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>&nbsp;Gestión a {{ infoPersona.nombreCompleto }}</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row v-if="!gestionAsignada || !tareaId">
            <v-col cols="6">
              <v-select
                :items="listaTiposGestion"
                v-model="gestion.tipoGestionId"
                item-text="descripcion"
                item-value="id"
                label="Área Gestión"></v-select>
            </v-col>

            <v-col cols="6">
              <v-select
                :items="listaTareasFiltered"
                v-model="gestion.tareaId"
                no-data-text="Debe elegir el tipo de gestión"
                item-text="descripcion"
                item-value="id"
                label="Tipo de Gestión"></v-select>
            </v-col>
          </v-row>

          <v-row v-if="gestion.tareaId == 64">
            <v-col cols="6">
              <v-select
                :items="listaOrigenMail"
                v-model="gestion.OrigenMailId"
                no-data-text="Debe elegir el tipo de gestión"
                item-text="descripcion"
                item-value="id"
                label="Origen"></v-select>
            </v-col>
          </v-row>

          <v-row v-if="gestion.tareaId == 601">
            <v-col cols="6">
              <v-select
                :items="listaOrigenRedes"
                v-model="gestion.OrigenRedesId"
                no-data-text="Debe elegir el tipo de gestión"
                item-text="descripcion"
                item-value="id"
                label="Origen"></v-select>
            </v-col>
          </v-row>

          <!-- v-if gestion telefonica-->

          <div
            v-if="
              tareaSeleccionada.esTelefonica && !tareaSeleccionada.esEntrante
            ">
            <v-row>
              <v-switch
                label="Llamar teléfono no agendado"
                v-model="llamarTelefonoNuevo">
              </v-switch>
            </v-row>

            <v-row v-if="!llamarTelefonoNuevo">
              <v-col cols="6">
                <v-select
                  :items="listaTelefonos"
                  v-model="gestion.telefonoContactadoId"
                  item-text="numero"
                  item-value="id"
                  label="Teléfono Contactado"></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="telefonoEs"
                  label="Es"
                  disabled></v-text-field>
              </v-col>
            </v-row>

            <v-row v-else>
              <v-col cols="6">
                <v-text-field
                  v-model="numeroTelefonoNuevo"
                  label="Teléfono"
                  v-validate="'required'"
                  data-vv-name="numero"
                  counter></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-select
                  :items="listaTiposPersonaContactada"
                  v-model="gestion.tipoPersonaContactadaId"
                  item-text="descripcion"
                  item-value="id"
                  label="Persona Ubicada"></v-select>
              </v-col>

              <v-col cols="3">
                <v-btn
                  class="ma-2 white--text"
                  rounded
                  v-if="ParametrosGenerales.integracionLlamadosAnura"
                  color="success"
                  @click.stop="llamadoAnura">
                  LLAMAR
                  <v-icon>phone_forward</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-row>
            <v-col cols="6">
              <v-autocomplete
                :items="listaRespuestas"
                v-model="gestion.respuestaId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Respuesta"
                loading="loadingRespuestas"></v-autocomplete>
            </v-col>

            <v-col cols="3">
              <v-btn
                class="ma-2 white--text"
                rounded
                v-if="gestion.respuestaId == 413"
                color="red"
                @click.stop="enviarSMS">
                ENVIAR SMS
              </v-btn>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaRespuestasGestionFiltered"
                v-model="gestion.respuestaDetalleId"
                v-if="listaRespuestasGestionFiltered.length > 0"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Respuesta Detalle"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <!--  v-if respuesta es promesa-->
              <v-text-field
                v-model="gestion.fechaPromesa"
                v-if="esPromesa"
                label="Fecha Promesa"
                type="date"
                prepend-icon="event"></v-text-field>
              <!--  v-if Importe de la respuesta es promesa-->
              <v-text-field
                v-model="gestion.importePromesa"
                v-if="esPromesa"
                label="Importe Promesa"
                type="likes"
                prepend-icon="$"></v-text-field>
            </v-col>
          </v-row>

          <v-row
            v-if="
              respuestaSeleccionada != null &&
              !esPromesa &&
              gestion.tareaId != 1033 &&
              gestion.tareaId != 1037 &&
              gestion.tareaId != 1038 &&
              gestion.tareaId != 1041 &&
              gestion.tareaId != 1045 &&
              gestion.tareaId != 1046
            ">
            <v-col cols="6">
              <v-switch label="Rellamar" v-model="gestion.rellamar"></v-switch>
            </v-col>

            <v-col cols="6">
              <!--  v-if respuesta es promesa-->
              <v-text-field
                v-model="gestion.fechaRellamado"
                label="Rellamar el"
                type="date"
                prepend-icon="event"></v-text-field>
            </v-col>
          </v-row>

          <!-- consumo post-venta -->
          <v-row v-if="esGestionConsumoPostVenta">
            <v-col cols="6">
              <v-autocomplete
                :items="listaAtencion"
                v-model="gestion.atencionId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Atención"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="productoAEntregar"
                label="Producto a Entregar"
                disabled></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaConfirmaMonto"
                v-model="gestion.retiraProductoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Retiró el Producto"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                :items="listaConfirmaMonto"
                v-model="gestion.confirmaProductoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Canfirmación de Prod."></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                :items="listaMotivoRespuesta"
                v-model="gestion.motivoRespuestaId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Motivo respuesta"></v-autocomplete>
            </v-col>

            {{ "xxxx " + gestion.reclamaTelefonoId }}

            <v-col cols="6">
              <v-autocomplete
                :items="listaReclamaTelefono"
                v-model="gestion.reclamaTelefonoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Reclama teléfono"></v-autocomplete>
            </v-col>
            {{ "xxxx " + gestion.reclamaTelefonoId }}
            <v-col cols="6">
              <v-autocomplete
                :items="listaMedioPagos"
                v-model="gestion.medioPagoId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Medio de pago"></v-autocomplete>
            </v-col>
          </v-row>

          <!-- calidad post-venta -->

          <v-row v-if="esGestionCalidadPostVenta">
            <v-col cols="6">
              <v-autocomplete
                :items="listaCanalVenta"
                v-model="gestion.CanalVentaId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Atención"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaObservacionAtencion"
                v-model="gestion.observacionAtencionId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Observación atención"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="montoRecibido"
                label="Monto recibido"
                disabled></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaConfirmaMonto"
                v-model="gestion.confirmaMontoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Confirma Monto"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaConformeCredito"
                v-model="gestion.conformeCreditoId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Conforme con crédito"></v-autocomplete>
            </v-col>

            <v-col cols="6" v-if="showListaNoConformeCredito">
              <v-autocomplete
                :items="listaNoConformeCredito"
                v-model="gestion.razonNoConformeCreditoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Razón"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaMotivoPrestamo"
                v-model="gestion.motivoCreditoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Motivo del préstamo"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaFormaLlegada"
                v-model="gestion.formaLlegadaId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Forma de llegada"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaMotivoRespuesta"
                v-model="gestion.motivoRespuestaId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Motivo respuesta"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaReclamaTelefono"
                v-model="gestion.reclamaTelefonoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Reclama teléfono"></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-select
                :items="listaProductos"
                v-model="gestion.productoId"
                v-if="gestion.tipoGestionId == 4"
                item-text="descripcion"
                item-value="id"
                label="Producto"></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="listaMedioPagos"
                v-model="gestion.medioPagoId"
                v-if="gestion.tipoGestionId == 4"
                item-text="descripcion"
                item-value="id"
                label="Medio de Pago"></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-if="gestion.tipoGestionId == 4"
                v-model="gestion.articulo"
                label="Artículo"
                single-line></v-text-field>
            </v-col>
            <!-- <v-col cols="6">
              <v-text-field
                v-if="gestion.tipoGestionId == 4"
                v-model="gestion.fechaCobro"
                label="Fecha de cobro"
                type="date"
                prepend-icon="event"
              ></v-text-field>
            </v-col> -->
          </v-row>

          <!-- Encuesta de Calidad-->
          <!-- {{
            "esgestionencuestacalidad: " +
            esGestionEncuestaDeCalidad +
            "Tarea ID: " +
            gestion.tareaId
          }} -->
          <v-row v-if="esGestionEncuestaDeCalidad">
            <v-col cols="6">
              <v-autocomplete
                :items="listaCanalVenta"
                v-model="gestion.CanalVentaId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Canal de Venta"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaTripleChoice"
                v-model="gestion.LeyoContrato"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="¿Leyó con atención el contrato?"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaConfirmaMonto"
                v-model="gestion.confirmaMontoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Confirma Monto"></v-autocomplete>
            </v-col>

            <v-col cols="6" v-if="MostrarOpcionesOcultas">
              <v-autocomplete
                :items="listaTripleChoice"
                v-model="gestion.Recomendaria"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="¿Recomendaría el servicio a un amigo?"></v-autocomplete>
            </v-col>

            <v-col cols="6" v-if="MostrarOpcionesOcultas">
              <v-autocomplete
                :items="listaTripleChoice"
                v-model="gestion.ProponeCambios"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="¿Propone algún cambio?"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaTripleChoice"
                v-model="gestion.ConoceAPPId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="¿Conoce la APP?"></v-autocomplete>
            </v-col>

            <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <v-autocomplete
                      :items="listaTipoAPPexperienciaGral"
                      v-model="gestion.APPexperienciaGralId"
                      placeholder="Seleccione una"
                      clearable
                      item-text="descripcion"
                      item-value="id"
                      label="¿Cómo calificarías tu experiencia general con la App?" />
                  </div>
                </template>
                <span
                  >¿Cómo calificarías tu experiencia general con la App?</span
                >
              </v-tooltip>
            </v-col>

            <!-- <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-autocomplete
                :items="listaTipoEncontroInformacion"
                v-model="gestion.EncontroInformacionId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="¿Encontraste rápidamente la información que buscabas?"></v-autocomplete>
            </v-col> -->

            <!-- <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-tooltip location="top">
                <template #activator="{ props }">
                  <v-autocomplete
                    v-bind="props"
                    :items="listaTipoEncontroInformacion"
                    v-model="gestion.EncontroInformacionId"
                    placeholder="Seleccione una"
                    clearable
                    item-text="descripcion"
                    item-value="id"
                    label="¿Encontraste rápidamente la información que buscabas?" />
                </template>
                <span
                  >Este campo permite calificar si el usuario encontró la
                  información fácilmente dentro de la App.</span
                >
              </v-tooltip>
            </v-col> -->

            <!-- <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-autocomplete
                    v-on="on"
                    :items="listaTipoEncontroInformacion"
                    v-model="gestion.EncontroInformacionId"
                    placeholder="Seleccione una"
                    clearable
                    item-text="descripcion"
                    item-value="id"
                    label="¿Encontraste rápidamente la información que buscabas?" />
                </template>
                <span>
                  Este campo permite calificar si el usuario encontró la
                  información fácilmente dentro de la App.
                </span>
              </v-tooltip>
            </v-col> -->

            <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <v-autocomplete
                      :items="listaTipoEncontroInformacion"
                      v-model="gestion.EncontroInformacionId"
                      placeholder="Seleccione una"
                      clearable
                      item-text="descripcion"
                      item-value="id"
                      label="¿Encontraste rápidamente la información que buscabas?" />
                  </div>
                </template>
                <span
                  >¿Encontraste rápidamente la información que buscabas?</span
                >
              </v-tooltip>
            </v-col>

            <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <v-autocomplete
                      :items="listaTipoProcesoSolicitud"
                      v-model="gestion.ProcesoSolicitudId"
                      placeholder="Seleccione una"
                      clearable
                      item-text="descripcion"
                      item-value="id"
                      label="¿El proceso de solicitud de crédito fue claro y sencillo?" />
                  </div>
                </template>
                <span
                  >¿El proceso de solicitud de crédito fue claro y
                  sencillo?</span
                >
              </v-tooltip>
            </v-col>

            <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <v-autocomplete
                      :items="listaTipoDemoraCompletarSol"
                      v-model="gestion.DemoraCompletarSolId"
                      placeholder="Seleccione una"
                      clearable
                      item-text="descripcion"
                      item-value="id"
                      label="¿Cuánto tiempo te tomó completar la solicitud?" />
                  </div>
                </template>
                <span>¿Cuánto tiempo te tomó completar la solicitud?</span>
              </v-tooltip>
            </v-col>

            <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <v-autocomplete
                      :items="listaTipoDemoraRespuestaSol"
                      v-model="gestion.DemoraRespuestaSolId"
                      placeholder="Seleccione una"
                      clearable
                      item-text="descripcion"
                      item-value="id"
                      label="¿En cuánto tiempo recibiste una respuesta tras solicitar el crédito?" />
                  </div>
                </template>
                <span
                  >¿En cuánto tiempo recibiste una respuesta tras solicitar el
                  crédito?</span
                >
              </v-tooltip>
            </v-col>

            <v-col cols="6" v-if="gestion.ConoceAPPId === 1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <v-autocomplete
                      :items="listaTipoSeguridadCompartirDatos"
                      v-model="gestion.SeguridadCompartirDatosId"
                      placeholder="Seleccione una"
                      clearable
                      item-text="descripcion"
                      item-value="id"
                      label="¿Te sentiste seguro/a compartiendo tus datos en la app?" />
                  </div>
                </template>
                <span
                  >¿Te sentiste seguro/a compartiendo tus datos en la app?</span
                >
              </v-tooltip>
            </v-col>

            <v-col cols="6">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" v-bind="attrs">
                    <v-autocomplete
                      :items="listaTipoResultadoAtencion"
                      v-model="gestion.ResultadoAtencionId"
                      placeholder="Seleccione una"
                      clearable
                      item-text="descripcion"
                      item-value="id"
                      label="Resultado de la Atención" />
                  </div>
                </template>
                <span>Resultado de la Atención</span>
              </v-tooltip>
            </v-col>

            <v-col cols="6" v-if="MostrarOpcionesOcultas">
              <v-autocomplete
                :items="listaTipoViaPrimerContacto"
                v-model="gestion.ViaPrimerContactoId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="¿Cómo nos conoció?"></v-autocomplete>
            </v-col>

            <v-col cols="6" v-if="MostrarOpcionesOcultas">
              <v-autocomplete
                :items="listaTipoManejoRedes"
                v-model="gestion.ManejoRedesId"
                placeholder="Seleccione una"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Manejo de Redes"></v-autocomplete>
            </v-col>

            <!-- 
            <v-col cols="6">
              <v-text-field
                v-model="montoRecibido"
                label="Monto recibido"
                disabled></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-autocomplete
                :items="listaConfirmaMonto"
                v-model="gestion.confirmaMontoId"
                placeholder="Seleccione uno"
                clearable
                item-text="descripcion"
                item-value="id"
                label="Confirma Monto"></v-autocomplete>
            </v-col>

  


 -->
          </v-row>

          <v-row>
            <v-textarea
              v-model="gestion.comentarios"
              class="mx-2"
              label="Comentarios Adicionales"
              prepend-icon="comment"
              clearable
              auto-grow></v-textarea>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="altaGestion"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ gestion }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { addDays, format } from "date-fns";

import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    gestion: {
      tareaId: 0,
      respuestaId: 0,
      respuestaDetalleId: 0,
      productoId: 0,
      medioPagoId: 0,
      articulo: "",
      fechaCobro: "",
      CanalVentaId: 0,
      ResultadoAtencionId: 0,
      LeyoContrato: 0,
      ConfirmaMonto: 0,
      Recomendaria: 0,
      ViaPrimerContactoId: 0,
      ProponeCambios: 0,
      ManejoRedesId: 0,
      ConoceAPPId: 0,
      OrigenMailId: 0,
      OrigenRedesId: 0,
      APPexperienciaGralId: 0,
      EncontroInformacionId: 0,
      ProcesoSolicitudId: 0,
      DemoraCompletarSolId: 0,
      DemoraRespuestaSolId: 0,
      SeguridadCompartirDatosId: 0,
    },
    created: false,
    loadingAcciones: false,
    loadingRespuestas: false,
    numTelefonoContactado: "",
    telefonoEs: "",
    infoPersona: {},
    listaTiposPersonaContactada: [],
    listaRespuestas: [],
    listaRespuestasGestion: [],
    listaTiposGestion: [],
    listaTareas: [],
    listaTelefonos: [],
    listaProductos: [],
    listaMedioPagos: [],
    listaAtencion: [],
    listaObservacionAtencion: [],
    listaConfirmaMonto: [],
    listaConformeCredito: [],
    listaNoConformeCredito: [],
    listaMotivoPrestamo: [],
    listaFormaLlegada: [],
    listaRespuestas2: [],
    listaMotivoRespuesta: [],
    listaReclamaTelefono: [],
    listaCanalVenta: [],
    listaTripleChoice: [],
    listaTipoResultadoAtencion: [],
    listaTipoViaPrimerContacto: [],
    listaTipoManejoRedes: [],

    listaTipoAPPexperienciaGral: [],
    listaTipoEncontroInformacion: [],
    listaTipoProcesoSolicitud: [],
    listaTipoDemoraCompletarSol: [],
    listaTipoDemoraRespuestaSol: [],
    listaTipoSeguridadCompartirDatos: [],

    llamarTelefonoNuevo: false,
    numeroTelefonoNuevo: "",
    listaOrigenMail: [],
    listaOrigenRedes: [],
    MostrarOpcionesOcultas: false,
    //tareaSeleccionada: {}
  }),
  props: {
    personaId: { type: String },
    telefonoId: { type: String },
    tareaId: { type: Number },
    gestionAsignada: { type: Boolean, default: false },
    tipoGestionId: { type: Number, default: 0 },
    isSubTask: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
  },
  async created() {
    if (this.personaId) {
      this.showId = false;

      await this.loadRespuestaDetalle();
      await this.loadTiposGestion();
      await this.loadTareas();

      // if(this.user.tipoGestionId){
      //     console.log(this.user.tipoGestionId)
      //     this.tipoGestionId = this.user.tipoGestionId;
      // }
      if (this.gestionAsignada) {
        //Si viene de la pantalla de gestiones asignadas asigno la tarea y el teléfono que viene.
        this.gestion = {
          responsable: this.user.login,
          personaId: this.personaId,
          telefonoContactadoId: this.telefonoId,
          tipoGestionId: this.tipoGestionId,
          tareaId: this.tareaId,
          respuestaId: 0,
        };
      } else {
        this.gestion = {
          tipoGestionId: this.tipoGestionId,
          responsable: this.user.login,
          personaId: this.personaId,
          tareaId: 0,
          respuestaId: 0,
        };
      }

      await this.loadDatosPersona();
      await this.loadTiposPersonaContactada();
      await this.loadTelefonosPersona();
      await this.loadTiposAtencion();
      await this.loadTiposObservacionAtencion();
      await this.loadTiposDisconformidadCredito();
      await this.loadTiposMotivoRespuesta();
      await this.loadProductos();
      await this.loadMediosPago();
      await this.loadTiposConfirmaMonto();
      await this.loadTiposConformeCredito();
      await this.loadTiposReclamaTelefono();
      await this.loadTiposFormaLlegada();
      await this.loadTiposMotivoSolicitud();
      await this.loadCanalesVenta();
      await this.loadTripleChoice();
      await this.loadTipoResultadoAtencion();
      await this.loadTipoViaPrimerContacto();
      await this.loadTipoManejoRedes();
      await this.loadTiposOrigenMail();
      await this.loadTiposOrigenRedes();

      await this.loadTiposAPPexperienciaGral();
      await this.loadTiposEncontroInformacion();
      await this.loadTiposProcesoSolicitud();
      await this.loadTiposDemoraCompletarSol();
      await this.loadTiposDemoraRespuestaSol();
      await this.loadTiposSeguridadCompartirDatos();

      this.created = true;
    }
  },
  computed: {
    ...mapGetters([
      "getActionFromLink",
      "user",
      "UiCustomUserSettings",
      "ParametrosGenerales",
    ]),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    listaTareasFiltered: function () {
      if (!this.listaTareas) return [];

      const listaTareasFiltrada = this.listaTareas.filter(
        (e) => e.tipoGestionId == this.gestion.tipoGestionId
      );

      return listaTareasFiltrada;
    },
    listaRespuestasGestionFiltered: function () {
      if (!this.listaRespuestasGestion) return [];
      const listaRespuestaDetaleFiltrada = this.listaRespuestasGestion.filter(
        (e) =>
          e.tareaId == this.gestion.tareaId &&
          e.respuestaId == this.gestion.respuestaId
      );
      return listaRespuestaDetaleFiltrada;
    },
    tareaSeleccionada: function () {
      var item = this.listaTareas.find((i) => i.id == this.gestion.tareaId);
      return item == null ? { esTelefonica: false } : item;
    },
    esPromesa: function () {
      if (!this.respuestaSeleccionada) return false;

      return this.respuestaSeleccionada.descripcion
        .toLowerCase()
        .includes("promesa");
    },
    esGestionCalidadPostVenta: function () {
      if (!this.gestion.tipoGestionId || !this.gestion.tareaId) return false;

      return (
        this.gestion.tipoGestionId == 4 &&
        (this.gestion.tareaId == 401 || this.gestion.tareaId == 403)
      );
    },
    esGestionConsumoPostVenta: function () {
      if (!this.gestion.tipoGestionId || !this.gestion.tareaId) return false;

      return (
        this.gestion.tipoGestionId == 13 &&
        (this.gestion.tareaId == 1026 || this.gestion.tareaId == 1027)
      );
    },

    esGestionEncuestaDeCalidad: function () {
      if (!this.gestion.tipoGestionId || !this.gestion.tareaId) return false;

      // return (
      //   this.gestion.tipoGestionId == 16 &&
      //   (this.gestion.tareaId == 1065 ||
      //     this.gestion.tareaId == 1066 ||
      //     this.gestion.tareaId == 1067 ||
      //     this.gestion.tareaId == 1068)
      // );

      return this.gestion.tipoGestionId == 16 && this.gestion.tareaId == 1065;
    },

    respuestaSeleccionada: function () {
      if (!this.gestion.respuestaId) return null;

      var item = this.listaRespuestas.find(
        (i) => i.id == this.gestion.respuestaId
      );

      if (item != null && item.rellamar) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.gestion.rellamar = true;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.gestion.fechaRellamado = format(
          addDays(new Date(), 1),
          "YYYY-MM-DD"
        );
      }
      return item;
    },
    showListaNoConformeCredito: function () {
      const selectedConforme = this.listaConformeCredito.find(
        (x) => x.id === this.gestion.conformeCreditoId
      );
      return selectedConforme && selectedConforme.descripcion === "No";
    },
  },
  watch: {
    visible: function () {
      if (this.visible) {
        this.showId = false;
        this.loadDatosPersona();
      }
    },
    numTelefono: function () {
      this.gestion.numTelefonoContactado = this.numTelefono;
    },
    // en el área de gestión CALIDAD-POSTVENTA

    "gestion.tipoGestionId": function () {
      if (this.created) this.gestion.tareaId = 0;

      this.listaRespuestas = [];

      if (this.gestion.tipoGestionId == 4) {
        //carga N/A en los valores de los combos.
        this.gestion.atencionId = 6;
        this.gestion.observacionAtencionId = 4;
        this.gestion.confirmaMontoId = 3;
        this.gestion.conformeCreditoId = 3;
        this.gestion.motivoCreditoId = 1;
        this.gestion.formaLlegadaId = 22;
        this.gestion.productoId = 0;
        this.gestion.tipoPersonaContactadaId = 8;
        this.gestion.medioPagoId = 8;
        this.gestion.motivoRespuestaId = 5;
        this.gestion.reclamaTelefonoId = 3;
      }
    },
    "gestion.tareaId": function () {
      this.loadRespuestas();

      // if(!this.gestion || this.gestion.tareaId ==0  || this.listaTareas.length == 0 )
      //     this.tareaSeleccionada = { esTelefonica: false};
      // else
      // {
      //     var item =this.listaTareas.find(i=>i.id == this.gestion.tareaId)
      //     this.tareaSeleccionada = item;
      // }
    },
    "gestion.respuestaId": function () {
      this.gestion.fechaPromesa =
        this.gestion.respuestaId == 1
          ? format(addDays(new Date(), 1), "YYYY-MM-DD")
          : null;
    },

    "gestion.telefonoContactadoId": function () {
      this.updateInfoTelefono();
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "hideActiveTask",
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async altaGestion() {
      if (!this.validarDatos()) return;

      if (this.llamarTelefonoNuevo) {
        this.gestion.telefonoContactadoId = null;
        this.gestion.comentarios = this.gestion.comentarios
          ? this.gestion.comentarios +
            " // Contacto con teléfono no agendado: " +
            this.numeroTelefonoNuevo
          : "Contacto con teléfono no agendado: " + this.numeroTelefonoNuevo;
      }

      this.loading = true;
      try {
        var result = await http.post(
          "gestion",
          JSON.stringify({ gestion: this.gestion })
        );

        this.alertSuccess("Se ha guardado la gestión.");
        this.gestion = {};
        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validarDatos() {
      if (!this.gestion.tipoGestionId) {
        this.alertWarning("Debe elegir un tipo de gestión.");
        return false;
      }

      if (this.gestion.tipoGestionId == 4) {
        if (this.gestion.productoId == null) {
          this.alertWarning("Debe elegir un producto.");
          return false;
        }
        if (this.gestion.medioPagoId == null) {
          this.alertWarning("Debe elegir un medio de pago.");
          return false;
        }
      }

      //tipo gestión telefónica
      if (
        this.tareaSeleccionada.esTelefonica &&
        !this.tareaSeleccionada.esEntrante
      ) {
        if (this.llamarTelefonoNuevo) {
          if (!this.numeroTelefonoNuevo) {
            this.alertWarning("Debe ingresar el número de teléfono.");
            return false;
          }
        } else {
          if (!this.gestion.telefonoContactadoId) {
            this.alertWarning("Debe elegir un Teléfono Contactado.");
            return false;
          }
        }

        if (!this.gestion.tipoPersonaContactadaId) {
          this.alertWarning("Debe elegir un tipo de Persona Ubicada.");
          return false;
        }
      }

      if (this.esGestionCalidadPostVenta) {
        if (!this.gestion.atencionId) {
          this.alertWarning("Debe elegir una Respuesta de Atención.");
          return false;
        }

        if (!this.gestion.confirmaMontoId) {
          this.alertWarning("Debe confirmar el Monto.");
          return false;
        }

        if (!this.gestion.conformeCreditoId) {
          this.alertWarning("Debe elegir una respuesta.");
          return false;
        }

        if (!this.gestion.motivoCreditoId) {
          this.alertWarning("Debe elegir un Motivo del Préstamo.");
          return false;
        }

        if (!this.gestion.formaLlegadaId) {
          this.alertWarning("Debe elegir una Forma de Llegada.");
          return false;
        }

        if (!this.gestion.medioPagoId) {
          this.alertWarning("Debe elegir un Medio de Pago.");
          return false;
        }
      }

      if (this.esGestionConsumoPostVenta) {
        if (!this.gestion.atencionId) {
          this.alertWarning("Debe elegir una Respuesta de Atención.");
          return false;
        }

        if (!this.gestion.medioPagoId) {
          this.alertWarning("Debe elegir un Medio de Pago.");
          return false;
        }
      }

      if (!this.gestion.tareaId) {
        this.alertWarning("Debe elegir una tarea.");
        return false;
      }

      if (!this.gestion.respuestaId) {
        this.alertWarning("Debe elegir una respuesta.");
        return false;
      }

      if (this.esPromesa && !this.gestion.fechaPromesa) {
        this.alertWarning("Debe ingresar la Fecha de Promesa.");
        return false;
      }

      if (this.esPromesa && !this.gestion.importePromesa) {
        this.alertWarning("Debe ingresar el Monto de Promesa.");
        return false;
      }
      if (
        this.listaRespuestasGestionFiltered.length > 0 &&
        !this.gestion.respuestaDetalleId
      ) {
        this.alertWarning("Debe ingresar la Respuesta de Gestion.");
        return false;
      }

      return true;
    },
    async loadDatosPersona() {
      this.loading = true;
      try {
        var result = await http.get(
          "personas/inforesumida?cargarInfoUltimoCredito=true&id=" +
            this.personaId
        );
        console.log("info ultimo credito");
        console.log(result);

        this.infoPersona = result;
        this.montoRecibido = this.infoPersona.montoUltimoCredito;
        this.productoAEntregar = this.infoPersona.producrtoUltimoCredito;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposPersonaContactada() {
      this.loading = true;
      try {
        await http.get("tipostelefonopertenencia").then((res) => {
          this.listaTiposPersonaContactada = res.list;
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposGestion() {
      this.loading = true;
      try {
        var result = await http.get("tiposgestion");

        this.listaTiposGestion = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTareas() {
      this.loading = true;
      try {
        var result = await http.get(
          "gestion/listtareasgestion?habilitada=true"
        );

        this.listaTareas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadRespuestaDetalle() {
      this.loading = true;
      try {
        var result = await http.get("gestion/listrespuestasgestiondetalle");
        console.log(result.list);

        this.listaRespuestasGestion = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadRespuestas() {
      if (!this.gestion || !this.gestion.tareaId) return;

      this.loadingRespuestas = true;
      try {
        var result = await http.get(
          "gestion/listrespuestastareagestion?tareaId=" + this.gestion.tareaId
        );

        this.listaRespuestas = result.list;

        //si es calidad, muestro NO CONTACTADO

        if (this.gestion.tipoGestionId == 16)
          if (this.listaRespuestas.length > 1)
            this.gestion.respuestaId = this.listaRespuestas[1].id;
          // selecciona la 2ra
          else if (this.listaRespuestas.length > 0)
            this.gestion.respuestaId = this.listaRespuestas[0].id; // selecciona la 1ra
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingRespuestas = false;
    },
    async loadTelefonosPersona() {
      this.loading = true;

      try {
        await http
          .get("personas/listtelefonos/" + this.personaId)
          .then((res) => {
            this.listaTelefonos = res;

            //si viene de una gestion asignada seteo el telefono a contactar
            if (this.gestionAsignada) this.updateInfoTelefono();
          });
      } catch (error) {
        this.alertError(error);
      }
    },

    async loadTiposOrigenMail() {
      this.loading = true;
      try {
        var result = await http.get("/tiposorigenmail"); // traigo todas
        this.listaOrigenMail = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTiposOrigenRedes() {
      this.loading = true;
      try {
        var result = await http.get("/tiposorigenredes"); // traigo todas
        this.listaOrigenRedes = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTiposAPPexperienciaGral() {
      this.loading = true;
      try {
        var result = await http.get("/tiposAPPexperienciaGral"); // traigo todas
        this.listaTipoAPPexperienciaGral = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTiposEncontroInformacion() {
      this.loading = true;
      try {
        var result = await http.get("/tiposEncontroInformacion"); // traigo todas
        this.listaTipoEncontroInformacion = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTiposProcesoSolicitud() {
      this.loading = true;
      try {
        var result = await http.get("/tiposProcesoSolicitud"); // traigo todas
        this.listaTipoProcesoSolicitud = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTiposDemoraCompletarSol() {
      this.loading = true;
      try {
        var result = await http.get("/tiposDemoraCompletarSol"); // traigo todas
        this.listaTipoDemoraCompletarSol = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTiposDemoraRespuestaSol() {
      this.loading = true;
      try {
        var result = await http.get("/tiposDemoraRespuestaSol"); // traigo todas
        this.listaTipoDemoraRespuestaSol = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTiposSeguridadCompartirDatos() {
      this.loading = true;
      try {
        var result = await http.get("/tiposSeguridadCompartirDatos"); // traigo todas
        this.listaTipoSeguridadCompartirDatos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get("productos/");

        this.listaProductos = result.list;

        this.listaProductos.unshift({ id: 0, descripcion: "(Todos)" });
        console.log("MICAAAA");
        console.log(this.listaProductos);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposAtencion() {
      this.loading = true;
      try {
        var result = await http.get("tiposatencion"); // traigo todas
        this.listaAtencion = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposObservacionAtencion() {
      this.loading = true;
      try {
        var result = await http.get("tiposobservacionatencion"); // traigo todas
        this.listaObservacionAtencion = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposConfirmaMonto() {
      this.loading = true;
      try {
        var result = await http.get("tiposconfirmamonto"); // traigo todas
        this.listaConfirmaMonto = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposConformeCredito() {
      this.loading = true;
      try {
        var result = await http.get("tiposconformecredito"); // traigo todas
        this.listaConformeCredito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposReclamaTelefono() {
      this.loading = true;
      try {
        var result = await http.get("tiposreclamatelefono"); // traigo todas
        this.listaReclamaTelefono = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposDisconformidadCredito() {
      this.loading = true;
      try {
        var result = await http.get("tiposdisconformidadcredito"); // traigo todas
        this.listaNoConformeCredito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposMotivoSolicitud() {
      this.loading = true;
      try {
        var result = await http.get("tiposdestinocredito"); // traigo todas
        this.listaMotivoPrestamo = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposFormaLlegada() {
      this.loading = true;
      try {
        var result = await http.get("tiposformallegada"); // traigo todas
        this.listaFormaLlegada = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposMotivoRespuesta() {
      this.loading = true;
      try {
        var result = await http.get("tiposmotivorespuesta"); // traigo todas
        this.listaMotivoRespuesta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMediosPago() {
      this.loading = true;
      try {
        var result = await http.get("tiposmediopagogestion"); // traigo todas
        this.listaMedioPagos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get("tiposcanalventa"); // traigo todas
        this.listaCanalVenta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTripleChoice() {
      this.loading = true;
      try {
        var result = await http.get("tripleChoice"); // traigo todas
        this.listaTripleChoice = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTipoResultadoAtencion() {
      this.loading = true;
      try {
        var result = await http.get("tipoResultadoAtencion"); // traigo todas
        this.listaTipoResultadoAtencion = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTipoViaPrimerContacto() {
      this.loading = true;
      try {
        var result = await http.get("tipoViaPrimerContacto"); // traigo todas
        this.listaTipoViaPrimerContacto = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTipoManejoRedes() {
      this.loading = true;
      try {
        var result = await http.get("tipoManejoRedes"); // traigo todas
        this.listaTipoManejoRedes = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    updateInfoTelefono() {
      if (this.listaTelefonos.length > 0) {
        var telefonoContactado = this.listaTelefonos.find(
          (t) => t.id === this.gestion.telefonoContactadoId
        );

        this.gestion.tipoPersonaContactadaId = telefonoContactado.perteneceA.id;

        this.telefonoEs = telefonoContactado.esCelular
          ? "Celular "
          : "Fijo " + telefonoContactado.perteneceA.descripcion;
        this.gestion.esTelefonoLaboral = telefonoContactado.esDeEmpleo;
      }
    },
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    emitGestionCompletada() {
      this.$emit("gestion-completada");
    },
    llamadoAnura() {
      Vue.$log.debug(this.UiCustomUserSettings.numeroInterno);
      if (!this.UiCustomUserSettings.numeroInterno) {
        this.alertWarning(
          "Debe configurar el número de interno de usuario para realizar el llamado."
        );
        return;
      }
      let numero = "";

      if (this.llamarTelefonoNuevo) {
        numero = this.numeroTelefonoNuevo;
      } else {
        let telefonoContactado = this.listaTelefonos.find(
          (t) => t.id === this.gestion.telefonoContactadoId
        );
        numero = telefonoContactado.numero;
      }

      try {
        http.get(
          "gestion/llamadoAnura?telefono=" +
            numero +
            "&numeroInterno=" +
            this.UiCustomUserSettings.numeroInterno
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async enviarSMS() {
      let filtro = {
        personaId: this.personaId,
        empresaId: 0,
        modeloId: 1013,
        tipoCampania: 1,
        fechaOption: 2,
      };
      try {
        this.loading = true;

        await http
          .post(
            "gestion/envioSmsPersonaPuntual",
            JSON.stringify({ parametros: filtro })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              this.alertError(resp.error);
            } else {
              this.alertSuccess("Se enviaron correctamente los SMS");
            }
          })
          .catch((e) => {
            this.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
